import React from 'react';
import { Container } from 'react-bootstrap';
import './maincontainer.css';
import { UserProfileDetailsProps } from '../profile/profile.types';

const MainContainer: React.FC<any> = (props: any) => {
  const { userId, profile } = props.userProfile;
  console.log({ profile });
  return (
    <Container className="py-5">
      <div className="row">
        {/* Columna izquierda con dos artículos */}
        <section className="col-md-8">
          <article className="firtsInfo bg-light p-5 mb-5 rounded-5 shadow">
            <h2>
              <strong>Mi perfil</strong>
            </h2>
            <div>
              <h6>
                <p>
                  ¡Hola {`${profile?.firstName} ${profile?.lastName}`}! Gracias por confiar en
                  nosotros para hacer crecer tu capital. Desde tu perfil puedes consultar el estado
                  de tu inversión y acceder a contenido exclusivo sobre estrategias financieras para
                  maximizar tu rentabilidad.
                </p>
                <p>📈 Tu inversión está en marcha, y estamos aquí para acompañarte en cada paso.</p>
                <p>🔍 ¿Quieres diversificar tu portafolio?</p>
              </h6>
              <br />
              <button
                className="btn btn-dark btn-lg"
                onClick={() => {
                  window.open('https://bellcapitalmx.com/services/', '_blank');
                }}
              >
                INVERTIR HOY
              </button>
            </div>
          </article>
          <article className="secondInfo bg-light p-5 mb-5 rounded-5 shadow">
            <h2>
              <strong>¿Necesitas ayuda?</strong>
            </h2>
            <div>
              <h6>
                <p>
                  Uno de nuestros especialistas puede resolver tus dudas del funcionamiento de
                  nuestra plataforma.
                  <br />
                  <br />
                  (998)-739-6511 / (998)-604-9511
                  <br />
                  <br />
                  <a href="mailto:contacto@bellcapitalmx.com">contacto@bellcapitalmx.com</a>
                </p>
              </h6>
              <br />
              <button
                className="btn btn-dark btn-lg"
                onClick={() => {
                  window.open('https://bellcapitalmx.com/contact/', '_blank');
                }}
              >
                CONTACTO
              </button>
            </div>
          </article>
        </section>

        {/* Columna derecha con un artículo */}
        <section className="col-md-4">
          <article className="thirddInfo bg-light p-5 mb-5 rounded-5 shadow">
            <h4>
              <strong>Inversiones seguras y estratégicas</strong>
            </h4>
            <div>
              <h6>
                <p>
                  Hacemos crecer tu capital con estrategias diversificadas en activos digitales,
                  mercado de valores y start-ups.
                </p>
                <p>
                  ¿Cómo garantizamos tu éxito?
                  <ol className="main-container-list">
                    <li>✔Más de 5 años de experiencia en gestión de inversiones. </li>
                    <li>✔Asesoría personalizada para alinear tu inversión con tus objetivos. </li>
                    <li>✔Evaluación constante de riesgos para una mayor seguridad financiera.</li>
                  </ol>
                  📌 Recuerda: Puedes ajustar tu estrategia en cualquier momento con el apoyo de
                  nuestros expertos.
                </p>
                <p>
                  ¿Quieres hablar con un asesor?
                  <br />
                  (998)-739-6511
                  <br />
                  (998)-604-9511
                </p>
              </h6>
            </div>
          </article>
        </section>
      </div>
    </Container>
  );
};

export default MainContainer;
